import { navigate } from 'gatsby';
import { useEffect, useState } from 'react';

import {
  generateLocationQueryString,
  getLocationQueryStringParam,
} from '~/utils/browser';
import { QUERY_STRING_PARAM_STRATEGY } from '~/utils/constants';

import { UsePaginationParams } from './models';

export const usePagination = <T extends unknown>({
  componentId,
  items,
  itemsPerPage,
}: UsePaginationParams<T>) => {
  const queryParam = componentId ? `${componentId}-page` : 'page';
  const queryParametersPage =
    (getLocationQueryStringParam(
      queryParam,
      QUERY_STRING_PARAM_STRATEGY.STRING
    ) as string) || '1';

  const [page, setPage] = useState<number>(parseInt(queryParametersPage, 10));
  const [visibleItems, setVisibleItems] = useState(items);

  useEffect(() => {
    if (page > 1) {
      navigate(generateLocationQueryString({ page: page.toString() }));
    }
  }, [page]);

  useEffect(() => {
    if (itemsPerPage) {
      const start = itemsPerPage * (page - 1);
      const end = start + itemsPerPage;

      setVisibleItems(items.slice(start, end));

      return;
    }

    setVisibleItems(items);
  }, [items, itemsPerPage, page]);

  return {
    visibleItems,
    page,
    setPage,
  };
};
